<template>
  <el-popover
    placement="top-start"
    title=""
    width="518"
    trigger="hover"
    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
  >
    <div slot="reference" class="popover-btn text-danger flex font-14">
      <slot>
        <img src="@/assets/images/signature/excel-icon.png" alt="" />
        Excel签章排版！
      </slot>
    </div>
    <div class="popover-content">
      <div>
        1.excel文件如果需要签章，请先将纸张方向调整为
        <span class="text-danger">横向</span>
        ，以确保签章时内容最大化展示，同时减少换行。调整后再上传签章。
      </div>
      <div class="m-t-4">
        2.操作步骤：在excel顶部找到【页面布局】->
        靠左的位置找到【纸张方向】->设置
        <span class="text-danger">【横向】</span>
      </div>
      <img src="@/assets/images/signature/excel-operation.png" alt="" />
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'ExcelTip'
}
</script>

<style scoped lang="scss">
.popover-btn {
  display: inline-block;

  img {
    width: 14px;
    height: auto;
    vertical-align: -2px;
  }
}

.popover-content {
  line-height: 1.5;

  img {
    margin-top: 12px;
    width: 100%;
    height: auto;
  }
}
</style>
